import { render, staticRenderFns } from "./ThePlantsSelector.vue?vue&type=template&id=72868b5e&scoped=true"
import script from "./ThePlantsSelector.vue?vue&type=script&lang=js"
export * from "./ThePlantsSelector.vue?vue&type=script&lang=js"
import style0 from "./ThePlantsSelector.vue?vue&type=style&index=0&id=72868b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72868b5e",
  null
  
)

export default component.exports